import React from 'react';
import { useAppDispatch, useAppSelector } from 'redux/hooks/reduxHooks';
import { selectPermissionModal } from 'redux/selectors/selectors';
import { closePermissionModal } from 'redux/slices/modals/modals.slice';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { smallModalPadding, smallModalClosePosition } from 'shared/constants/mui-constants';
import { CustomMuiIcon } from 'assets/images/icons/customMuiIcons';
import { EPermissionDeviceTypes, EPermissionValue } from 'shared/types/permission.interface';
import { PERMISSIONS_INFO } from 'shared/constants/permission-constants';
import { ModalContainer } from '../ModalContainer';

export const EnablePermissionsModal: React.FC = () => {
  const { isOpen, cameraStatus, microphoneStatus } = useAppSelector(selectPermissionModal);
  const dispatch = useAppDispatch();

  return (
    <ModalContainer
      isOpen={isOpen}
      onClose={() => dispatch(closePermissionModal())}
      padding={smallModalPadding}
      closeIconPosition={smallModalClosePosition}
    >
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{
          rowGap: { lg: '25px', md: '15px', sm: '15px', xs: '15px' },
          minHeight: { lg: '160px', md: '100px', sm: '100px', xs: '100px' },
        }}
      >
        {microphoneStatus !== EPermissionValue.Granted && (
          <>
            <Stack direction="row" columnGap={{ lg: '25px', md: '15px', sm: '15px', xs: '15px' }}>
              <CustomMuiIcon
                type={PERMISSIONS_INFO[EPermissionDeviceTypes.Microphone][microphoneStatus].icon}
                sx={{ fontSize: { lg: '60px', md: '50px', sm: '50px', xs: '50px' } }}
              />
            </Stack>
            <Typography variant="h2" color="primary.main" textAlign="center" textTransform="none">
              {PERMISSIONS_INFO[EPermissionDeviceTypes.Microphone][microphoneStatus].title}
            </Typography>
            <Typography variant="subtitle1" color="primary.main" textAlign="center">
              {PERMISSIONS_INFO[EPermissionDeviceTypes.Microphone][microphoneStatus].subtitle}
            </Typography>
          </>
        )}
        {cameraStatus !== EPermissionValue.Granted && (
          <>
            <Stack direction="row" columnGap={{ lg: '25px', md: '15px', sm: '15px', xs: '15px' }}>
              <CustomMuiIcon
                type={PERMISSIONS_INFO[EPermissionDeviceTypes.Camera][cameraStatus].icon}
                sx={{ fontSize: { lg: '60px', md: '50px', sm: '50px', xs: '50px' } }}
              />
            </Stack>
            <Typography variant="h2" color="primary.main" textAlign="center" textTransform="none">
              {PERMISSIONS_INFO[EPermissionDeviceTypes.Camera][cameraStatus].title}
            </Typography>
            <Typography variant="subtitle1" color="primary.main" textAlign="center">
              {PERMISSIONS_INFO[EPermissionDeviceTypes.Camera][cameraStatus].subtitle}
            </Typography>
          </>
        )}
      </Stack>
    </ModalContainer>
  );
};
